export default __webpack_public_path__ + "static/media/facebook-inactive.a992b881.svg";